import React from "react";

const ROLE_LABELS = {
  normal: "Normal / near-zero reference",
  marked: "Marked reference",
  intermediate: "Intermediate reference",
};

export default function ReferenceAnchorPlayer({
  anchors = [],
  currentConstructId,
  constructLabel,
  headingLabel,
  helpText,
  groups,
  getDisplayLabel,
  getAccessibleLabel,
  onReplay,
  disabled = false,
}) {
  const visible = anchors.filter(anchor =>
    !currentConstructId || anchor.constructId === currentConstructId
  );
  if (visible.length === 0) return null;

  const renderAnchor = anchor => {
    const displayLabel = getDisplayLabel?.(anchor) || anchor.label || ROLE_LABELS[anchor.role] || anchor.role;
    return <li className="av-reference-anchor" key={anchor.anchorId}>
      <span className="av-reference-anchor__role">{displayLabel}</span>
      <audio
        controls
        preload="metadata"
        src={anchor.contentUrl}
        aria-label={getAccessibleLabel?.(anchor, displayLabel) || `${displayLabel} for ${anchor.constructId}`}
        onPlay={event => {
          if (disabled) {
            event.currentTarget.pause();
            return;
          }
          onReplay?.(anchor);
        }}
        controlsList="nodownload"
        aria-disabled={disabled}
      />
    </li>;
  };

  const groupedAnchors = groups?.map(group => ({
    ...group,
    anchors: group.anchorIds.map(anchorId => visible.find(anchor => anchor.anchorId === anchorId)).filter(Boolean),
  })).filter(group => group.anchors.length > 0);

  return (
    <section className="av-reference-anchors" aria-label={constructLabel ? `${constructLabel} reference anchors` : "Reference anchors"}>
      <h3 className="av-reference-anchors__heading">{headingLabel || constructLabel || "Reference anchors"}</h3>
      <p className="av-reference-anchors__help">
        {helpText || "Use these optional reference sounds if they help you frame the judgment."}
      </p>
      {groupedAnchors?.length ? groupedAnchors.map(group => (
        <React.Fragment key={group.groupId}>
          {group.sectionLabel && <h4 className="av-reference-anchors__section-heading">{group.sectionLabel}</h4>}
          <section className="av-reference-anchors__group" aria-label={`${group.label} anchors`}>
            {group.sectionLabel
              ? <h5 className="av-reference-anchors__group-heading">{group.label}</h5>
              : <h4 className="av-reference-anchors__group-heading">{group.label}</h4>}
            <ul className={`av-reference-anchors__list${group.anchors.length === 1 ? " av-reference-anchors__list--single" : ""}${group.anchors.length === 3 ? " av-reference-anchors__list--three" : ""}`}>
              {group.anchors.map(renderAnchor)}
            </ul>
          </section>
        </React.Fragment>
      )) : (
        <ul className={`av-reference-anchors__list${visible.length === 3 ? " av-reference-anchors__list--three" : ""}`}>
          {visible.map(renderAnchor)}
        </ul>
      )}
    </section>
  );
}
